import useIsMobile from "../../../hooks/useIsMobile";
import ErrorBanner from "../../../components/ErrorPage/ErrorBanner";
import Head from "next/head";
import CommanContentBanner from "../../../components/commanContentBanner";
import CommonHomeCard from "../../../components/commonHomeCard";
import { configuration } from "../../../helpers/config";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import FAQ from "../../../components/Faq";
import $ from 'jquery'; // Import jQuery
import styles from "../../../styles/faq.module.css";
import style from "../../../styles/preference.module.css";
import AccordionGrid from "../../../components/accordion/AccordionGrid";
import { Constants } from "../../../helpers/constants";

export default function GenericTemplate(props) {
  const { data, error } = props;
  const isMobile = useIsMobile();
  const titleThemeState = {
    titleColor: "",
    titleFontSize: "",
  };
  const [titleTheme, setTitleTheme] = useState(titleThemeState);

  useEffect(() => {
    setTimeout(() => {
      let urlhash = window.location.hash?.slice(1);
      document.getElementById(urlhash)?.scrollIntoView();
    }, 100)
  }, [])

  useEffect(() => {
    setTitleTheme({
      ...titleTheme,
      titleColor: props.themeData?.cms_page_title_color,
      titleFontSize: props.themeData?.cms_page_title_font_size,
    });
  }, [props.themeData]);

  if (error) {
    return (
      <ErrorBanner
        image={`${configuration.IMG_STATIC_URL}errorBanner.png`}
        imageMob={`${configuration.IMG_STATIC_URL}errorMob.png`}
        error="404"
        desc="Sorry, the page you’re looking for doesn’t exist"
        btn="Go Back"
      />
    );
  }

  useEffect(() => {
    if (
      process.env.NEXT_PUBLIC_ALLOW_SCRIPT_TAG_PRICE == "true" &&
      data?.primary_details?.slug == "pricelist"
    ) {
      const list = document.querySelectorAll(".pricelist-tab li");
      const pricelist = document.querySelectorAll(".pricelist .pricelist-item");
      function activeLink(e) {
        list.forEach((item) => item.classList.remove("active"));
        // list.forEach((item) => item.classList.add('active'))
        e.classList.add("active");
        if (e.dataset.value == "all") {
          pricelist.forEach((item) => item.classList.remove("hide"));
        } else {
          pricelist.forEach((item) => {
            if (item.classList[1] === e.dataset.value) {
              item.classList.remove("hide");
            } else {
              item.classList.add("hide");
            }
          });
        }
      }
      list.forEach((item) =>
        item.addEventListener("click", (e) => activeLink(item))
      );
    }
    }, []);

  return (
    <div>
      <Head>
        <title>{data?.seo_settings?.meta_title}</title>
        <meta name="description" content={data?.seo_settings?.meta_desc} />
        <meta name="keywords" content={data?.seo_settings?.keywords} />
        <meta name="keywords" content={data?.seo_settings?.keywords} />
      </Head>
      <div className="genericPage__container">
        {/* banner */}
        <CommanContentBanner
          classname={"genericPage__container--banner bg-defaut-color"}  
          bannerSrc={
            isMobile ? data?.images?.mob_banner : data?.images?.desk_banner
          }
          videoLink={isMobile ? data?.mobile_video :data?.video}
          altText={isMobile ? data?.images?.mob_banner_alt1 || (data?.images?.mob_banner ? `Suzuki_${data?.images?.mob_banner?.split("/").pop()?.split(".")[0]}` : "") : data?.images?.desk_banner_alt1 || (data?.images?.desk_banner ? `Suzuki_${data?.images?.desk_banner?.split("/").pop()?.split(".")[0]}` : "")}
          bannerText={data?.primary_details?.banner_title}
          titleThemeData={titleTheme}
          vedio_info={isMobile ? data?.mobile_video_info && data?.mobile_video_info : data?.desktop_video_info && data?.desktop_video_info}
          info_popup_width ={isMobile ? "300px" : "700px"}
          info_popup_height={isMobile ? "300px" : undefined}
          modelHeight={isMobile ? "220px" : undefined}
          banner_height ={isMobile ? "60vh":"100%"}
          PlaybuttonHeightfromBottom={isMobile ? "110px" : "27px"}
          infobuttonHeightfromBottom={isMobile ? "112px" : "29px"}
        />

        {/* end of banner */}
        <div id="seosetting" className="container mx-auto px-[30px] md:px-[100px] mt-[50px]">
          {data?.highlights && data?.highlights.length > 0 && (
            <div className="grid grid-cols-1 gap-5  md:grid-cols-3">
              {data?.highlights.map((item, index) => (
                <CommonHomeCard
                  key={index}
                  imgSrc={ item?.image? `${configuration.IMG_URL}${item?.image}` : ""}
                  imgMobileSrc={ item?.image_mob? `${configuration.IMG_URL}${item?.image_mob}` : "" }
                  cardClassName="homeCms__cardLinks"
                  contentClassName={"md:max-w-[75%]"}
                  headClassName="h-[75px] lg:h-[75px] md:h-[75px] overflow-hidden"
                  descriptClass={"h-[64px] lg:h-[64px] md:h-[64px]"}
                  imgHeight={302}
                  imgWidth={545}
                  // videoLink={item?.column == 1 && !item?.isImage && page?.video}
                  imgMobileHeight={564}
                  imgMobileWidth={768}
                  cardTitle={item?.title}
                  cardDescription={item?.desc}
                  cardBtnText={"SEE DETAILS"}
                  cardLink={item?.ctaLink}
                  btnType={"button_dark_arrow"}
                />
              ))}
            </div>
          )}
          {data?.primary_details?.title_visibility && (
          <h1 className="genericPage__container--title mb-[32px]">
            {data?.primary_details?.title}
          </h1>
          )}
          {/*<div className="genericPage__container--shortdesc">*/}
          {/*  {data?.primary_details?.desc}*/}
          {/*</div>*/}
          <div className="genericPage__container--htmlcontent">
            <div className="unreset"
              dangerouslySetInnerHTML={{
                __html: data?.primary_details?.long_desc,
              }}
            />
            {data?.htmlContent && (
              <div className="unreset"
                dangerouslySetInnerHTML={{
                  __html: data?.htmlContent,
                }}
              ></div>
            )}

          </div>
          {/*faq code is added */}
          <FAQ faq_data={props.data}/>
        </div>
      </div>
      {props?.data?.primary_details?.tnc && (
          <div
          className="container unreset wordwrap"
          id="cms_pages_t&c"
            // className={`unreset my-10 sm:w-[90%] container ${
            //   !isBannerVisible && "mt-[100px]"
            // } ${newData?.fleet?.order_index === null ? "lg:w-[50%]" : ""}`}
            dangerouslySetInnerHTML={{
              __html: props?.data?.primary_details?.tnc,
            }}
          />
        )}
    </div>
  );
}
